export const csrfHeaderName = 'x-sprintdeck-csrf';
export const csrfHeaderValue = '1';
export const topicIcons = [
  'lightbulb',
  'users',
  'target',
  'rocket',
  'banknote',
  'megaphone',
  'presentation',
  'flag',
  'chart-line',
  'puzzle',
  'compass',
  'shield-check',
  'heart-handshake',
  'graduation-cap',
  'sparkles',
  'book-open',
  'brain',
  'bot',
  'code',
  'terminal',
  'cpu',
  'database',
  'server',
  'cloud',
  'smartphone',
  'globe',
  'network',
  'git-branch',
  'workflow',
  'kanban',
  'chart-pie',
  'trending-up',
  'goal',
  'trophy',
  'medal',
  'crown',
  'star',
  'gem',
  'heart',
  'thumbs-up',
  'party-popper',
  'zap',
  'flame',
  'sprout',
  'leaf',
  'earth',
  'mountain',
  'telescope',
  'atom',
  'flask-conical',
  'calculator',
  'school',
  'languages',
  'pen-tool',
  'palette',
  'camera',
  'video',
  'mic',
  'headphones',
  'message-circle',
  'handshake',
  'briefcase',
  'building-2',
  'wallet',
] as const;
export const topicColors = [
  '#4f46e5',
  '#2563eb',
  '#1e3a8a',
  '#0ea5e9',
  '#06b6d4',
  '#14b8a6',
  '#0f766e',
  '#10b981',
  '#15803d',
  '#65a30d',
  '#84cc16',
  '#ca8a04',
  '#f59e0b',
  '#b45309',
  '#f97316',
  '#ef4444',
  '#e11d48',
  '#db2777',
  '#ec4899',
  '#c026d3',
  '#a855f7',
  '#7c3aed',
  '#64748b',
  '#334155',
] as const;
export const reactionTypes = ['LIKE', 'INTERESTING', 'UNCLEAR', 'MORE_DETAILS'] as const;
export const questionLimits = { minLength: 3, maxLength: 300 } as const;
export const questionModerationActions = ['ANSWER', 'HIDE', 'RESTORE', 'PROJECT', 'UNPROJECT'] as const;
export const liveSocketPath = '/socket.io';
export const userRoles = ['PRESENTER', 'ADMIN'] as const;
export const userStatuses = ['PENDING', 'ACTIVE', 'DISABLED'] as const;
export const surveyQuestionTypes = [
  'CHOICE',
  'RATING',
  'WORD_CLOUD',
  'OPEN_TEXT',
  'QUIZ',
  'RANKING',
] as const;
export const surveyLimits = {
  titleMax: 160,
  promptMax: 300,
  questionsMax: 12,
  optionsMin: 2,
  optionsMax: 20,
  optionLabelMax: 120,
  ratingMin: 3,
  ratingMax: 10,
  wordsMax: 3,
  wordLengthMax: 25,
  openTextMax: 300,
  cloudWordsShown: 60,
  openAnswersShown: 40,
} as const;
export const surveyControlActions = [
  'SHOW_QUESTION',
  'PROJECT',
  'UNPROJECT',
  'PHONE_RESULTS_ON',
  'PHONE_RESULTS_OFF',
  'REVEAL',
  'HIDE_ANSWER',
  'RESTORE_ANSWER',
  'CLOSE',
  'REOPEN',
] as const;
export const joinCodePattern = /^[A-HJ-NP-Z2-9]{6}$/;
export const joinCodeLength = 6;
export const slideNotesMaxLength = 10_000;
